<template>
    <div class="slide-show" v-cloak>

        <div data-slider>

            <div class="swiper-wrapper">

                <slot></slot>

            </div>

            <div class="swiper-pagination"></div>

            <div class="swiper-button-next swiper-button-white"></div>
            <div class="swiper-button-prev swiper-button-white"></div>

        </div>

    </div>
</template>
<script>
    export default {
        mounted() {
            this.dispatchEvent(true);
        },
        methods: {
            dispatchEvent(active) {
                this.$parent.$emit('slide-show-active', { active });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/src/components/SlideShow/SlideShowWrapper.vue